export const customStyles = {
  bannerContainer: {
    maxWidth: 350,
  },
};
